import { DriversState } from '../../types';

export const resetDriverLocations = (
  state: DriversState
) => {
  state.locations.data = undefined;
  state.locations.loadingStatus = undefined;
}